import { ShellFrame, type AppShellProps } from "./ShellFrame";

export function BrowseShell(props: AppShellProps) {
  return <ShellFrame {...props} routeSurface="browse" />;
}
